<template>
  <!-- 蔚蓝时代 -->
  <div class="v3-style" :style="getStyleContainerStyle()" @click="handleClick">
    <img class="header-bg" src="@/assets/img/style3/header_bg.png" v-if="!isMobile" />
    <div class="header-left" v-if="!isMobile">
      <!-- <img class="header-bg" src="@/assets/img/style2/header_left_bg.png" /> -->
      <div class="header-left-show-infos">
        <div class="info-item">
          <p :style="getHeaderInfopStyle()">
            <i class="iconfont icon-chaye"></i>
            湿度 {{ humidity }} %
          </p>
        </div>
        <div class="info-item">
          <p :style="getHeaderInfopStyle()">空气质量：{{ aqiName }}</p>
        </div>
        <div class="info-item" @click="toggleChartShow">
          <div
            class="icon"
            :style="getHeaderInfopStyle()"
            v-if="icon1?.iconUrl"
            @click.stop="handleJump(icon1?.url)"
          >
            <el-tooltip :content="headerIcon1Name" placement="bottom">
              <img :src="icon1.iconUrl" alt="" />
            </el-tooltip>
          </div>
          <p :style="getHeaderInfopStyle()">
            <el-tooltip :content="!isHideAllCharts ? '隐藏全部图表' : '显示全部图表'" placement="bottom">
              <i :class="!isHideAllCharts ? 'iconfont icon-huabankaobei-' : 'iconfont icon-yanjing-guan'"></i>
            </el-tooltip>
          </p>
        </div>
      </div>
    </div>
    <div class="header-middle" v-if="!isMobile">
      <div class="header-middle-filter"></div>
      <div
        class="header-ProjectName"
        :style="{
          fontSize: $w_Ratio(26, $store) + 'px',
          lineHeight: $h_Ratio(style.height - 20, $store) + 'px',
        }"
      >
        <p>{{ $store.state.ProjectInfo.Name }}</p>
      </div>

      <div class="spotlight-ct">
        <div class="spotLight1"></div>
        <div class="spotLight2"></div>
      </div>
    </div>
    <div class="header-right" v-if="!isMobile">
      <!-- <img class="header-bg" src="@/assets/img/style2/header_right_bg.png" /> -->
      <div class="header-right-show-infos">
        <div class="info-item0"></div>
        <div class="info-item1">
          <p :style="getHeaderInfopStyle()">{{ `${city} ${weather} ${temperature}°C` }}</p>
        </div>
        <!-- :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }" -->
        <div class="info-item2">
          <div class="info-item2-wrapper">
            <div class="info-item2-hour">
              <div v-for="(item, index) in timeString" :key="index">
                <img :src="`./img/timeicons/timeIcon${item}.png`" alt="" />
              </div>
            </div>
            <div class="info-item2-date">
              <div v-for="(item, index) in dateString" :key="index">
                <img :src="`./img/timeicons/timeIcon${item}.png`" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="info-item3">
          <div
            class="icon icon2"
            :style="getHeaderInfopStyle()"
            v-if="icon2?.iconUrl"
            @click.stop="handleJump(icon2?.url)"
          >
            <el-tooltip :content="headerIcon2Name" placement="bottom">
              <img :src="icon2.iconUrl" alt="" />
            </el-tooltip>
          </div>
          <p :style="getHeaderInfopStyle()">
            <!--<span>控件</span>-->
          </p>
        </div>
      </div>
    </div>
    <div
      class="right-icon"
      :style="getRightInfopStyle()"
      v-if="icon3?.iconUrl"
      @click.stop="handleJump(icon3?.url)"
    >
      <div>
        <img :src="icon3.iconUrl" alt="" />
      </div>
      <div class="right-name">
        {{ headerIcon3Name }}
      </div>
    </div>

    <div class="customer" :style="getCustomerStyle(isCall?.position)" v-if="isCall?.isShow">
      <div :class="[iframeUrlShow ? 'call-frame active-list' : 'call-frame']">
        <iframe
          :src="isCall?.aiUrl"
          style="width: 100%; height: 100%"
          frameborder="0"
          allow="microphone"
        ></iframe>
        <img src="@/assets/img/ai-model/call.png" alt="" />
        <!-- <img class="bg-top" src="@/assets/img/ai-model/call_top.png" alt="" />
        <img class="bg-left" src="@/assets/img/ai-model/call_left.png" alt="" />
        <img class="bg-right" src="@/assets/img/ai-model/call_right.png" alt="" />
        <img class="bg-bot" src="@/assets/img/ai-model/call_bot.png" alt="" /> -->
      </div>
      <div class="call-button">
        <img
          :class="`call-img-${isCall.model}`"
          v-if="isCall?.isShow"
          :src="imageSrc"
          @click="iframeShow"
          alt=""
        />
      </div>
    </div>
    <!-- 手机端 -->
    <img class="header-bg" src="@/assets/img/mobile/style3/header_bg.png" v-if="isMobile" />

    <div class="header-middle" v-if="isMobile">
      <div class="header-middle-filter"></div>
      <div
        class="header-ProjectName"
        :style="{
          fontSize: $w_Ratio(22, $store) + 'px',
          lineHeight: $h_Ratio(style.height - 16, $store) + 'px',
        }"
      >
        <p>{{ $store.state.ProjectInfo.Name }}</p>
      </div>

      <div class="spotlight-ct">
        <div class="spotLight1"></div>
        <div class="spotLight2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import provinceCoordinate from '../../charts/EarthCharts/Earth1Charts/provinceCoordinate';
import { request } from '../../../common/request';
import adcode from '@/components/common/weatherModule/adcode.json';
import jsonp from 'jsonp';
export default {
  name: 'V3Style',
  components: {},
  props: {
    Configuration: Object,
    ProjectInfo: Object,
  },
  data() {
    return {
      style: {
        height: 80,
      },
      iframeUrlShow: false,
      timeString: '',
      dateString: '',
      cityName: '',
      province: '',
      city: '',
      aqiName: '', // 空气质量
      humidity: '',
      temperature: '',
      weather: '',
      icon1: { isShowIcon: false, iconUrl: '', url: '' }, // 图标1
      icon2: { isShowIcon: false, iconUrl: '', url: '' }, // 图标2
      icon3: { isShowIcon: false, iconUrl: '', url: '' }, // 图标3
      headerIcon2Name: '', // 跳转图标2名称
      headerIcon3Name: '', // 跳转图标3名称
      headerIcon1Name: '', // 跳转图标1名称
      headerLon: '',
      headerLat: '',
      isCall: { isShow: false, position: 'right' },
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (val) {
        this.headerIcon3Name = val.propertyData.headerIcon3.value.name;
        this.isCall = val.propertyData?.customerservice?.value;
        this.onConfigurationChange();
      },
    },
  },
  created() {
    this.onConfigurationChange();
    this.autoGetTime();
  },
  mounted() {
    this.headerIcon2Name = this.Configuration.propertyData?.headerIcon2?.value?.name;
    this.headerIcon1Name = this.Configuration.propertyData?.headerIcon1?.value?.name;
    this.headerIcon3Name = this.Configuration.propertyData?.headerIcon3?.value?.name;
    this.cityName = this.Configuration.propertyData?.cityName?.value;
    this.headerLon = this.Configuration.propertyData?.headerLngLatData?.value?.lon;
    this.headerLat = this.Configuration.propertyData?.headerLngLatData?.value?.lat;
    this.isCall = this.Configuration.propertyData?.customerservice?.value;
    this.getWeather();
  },
  methods: {
    iframeShow() {
      if (this.isCall.aiUrl) {
        this.iframeUrlShow = !this.iframeUrlShow;
      } else {
        this.$ElMessage.warning('请输入对应的地址！');
      }
    },
    handleJump(url) {
      if (url) {
        window.open(url);
      } else {
        this.$ElMessage.warning('请配置地址！');
      }
    },
    toggleChartShow() {
      if (!this.isHideAllCharts) {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'hide',
          isAll: true,
        });
      } else {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'norm',
          isAll: true,
        });
      }
    },
    onConfigurationChange() {
      this.style.backgroundColor = this.Configuration.propertyData.headerBackgroundColor.value;

      this.icon1 = this.Configuration?.propertyData?.headerIcon1?.value;
      this.icon2 = this.Configuration?.propertyData?.headerIcon2?.value;
      this.icon3 = this.Configuration?.propertyData?.headerIcon3?.value;
    },
    getAdcodeByCityName(cityName) {
      if (!adcode || !Array.isArray(adcode)) {
        return null;
      }
      const normalizedCityName = cityName.replace(/省|市|区|县/g, '').trim();
      const matchedCity = adcode.find(item => {
        const normalizedItemName = item.name.replace(/省|市|区|县/g, '').trim();
        return (
          normalizedItemName.includes(normalizedCityName) || normalizedCityName.includes(normalizedItemName)
        );
      });

      if (matchedCity) {
        return matchedCity.adcode;
      } else {
        return null;
      }
    },
    getWeather() {
      const adcode = this.getAdcodeByCityName(this.cityName);
      if (!adcode) {
        return;
      }
      let weekly = `https://restapi.amap.com/v3/weather/weatherInfo?city=${adcode}&key=fabd72aad77a70e89c255d26a9f730b2&extensions=base`;

      jsonp(weekly, (err, res) => {
        if (!err) {
          let { humidity, temperature, weather, city, province } = res.lives[0];
          this.humidity = humidity;
          this.temperature = temperature;
          this.weather = weather;
          this.city = city;
          this.aqiName = '良好';
        }
      });
    },
    getHeaderInfopStyle(fs = 12, pt = 15) {
      return {
        paddingTop: this.$h_Ratio(pt, this.$store) + 'px',
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
        // transform: `scale(${this.$w_Ratio(1, this.$store)})`,
      };
    },
    getRightInfopStyle(fs = 14, pt = 15) {
      return {
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
      };
    },
    getCustomerStyle(val) {
      if (val == 'right') {
        return {
          right: 0,
        };
      }
      return {
        left: 0,
      };
    },

    getStyleContainerStyle() {
      return {
        height: this.$h_Ratio(this.style.height, this.$store) + 'px',
        backgroundColor: this.style.backgroundColor,
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    autoGetTime() {
      let padaDate = function (value) {
        // 时间不足十补零
        return value < 10 ? '0' + value : value;
      };
      setInterval(() => {
        const date = new Date();
        // console.log(date);
        const year = date.getFullYear(); //存储年
        const month = padaDate(date.getMonth() + 1); //存储月份
        const day = padaDate(date.getDate()); //存储日期
        const hours = padaDate(date.getHours()); //存储时
        const minutes = padaDate(date.getMinutes()); //存储分
        const seconds = padaDate(date.getSeconds()); //存储秒
        //返回格式化后的日期
        this.dateString = year + 'D' + month + 'D' + day;
        this.timeString = hours + 'T' + minutes + 'T' + seconds;
      }, 1000);
    },
  },
  computed: {
    ...mapState({
      isHideAllCharts: state => state.ProjectInfo.isHideAllCharts,
      isMobile: state => state.isMobile,
      pointList: state => state.pointList,
    }),
    imageSrc() {
      return require(`@/assets/img/ai-model/${this.isCall?.model}2.png`);
    },
  },
  Configuration: {
    componentTitle: '蔚蓝时代',
    componentName: 'V3Style',
    componentOverViewImg: './img/styles/style3.png',
    backgroundImg: './img/backgrounds/background_img/V3.png',
    backgroundImgMobile: `./img/backgrounds/background_img/mobile/V3.png`,
    propertyData: {
      cityName: {
        propertyComponentName: 'SingleInputor',
        value: '杭州',
        lable: '定位城市',
      },
      headerLngLatData: {
        propertyComponentName: 'MapLatLon',
        value: {
          lon: '120.15',
          lat: '30.28',
        },
      },
      headerBackgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        value: 'rgba(25, 36, 45, 0)',
        lable: '头部背景颜色',
      },
      menuStyle: {
        value: {
          height: 75,
          width: 700,
        },
      },
      headerIcon1: {
        propertyComponentName: 'HeaderIcon1Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
      headerIcon2: {
        propertyComponentName: 'HeaderIcon2Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
      headerIcon3: {
        propertyComponentName: 'HeaderIcon3Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
      customerservice: {
        propertyComponentName: 'AiCustomerService',
        value: {
          isShow: false,
          position: 'right',
          aiUrl:
            'https://amobilem.xyabcd.com/aiservice/live2d/?personId=4&model=Haru&speed=5&volume=5&bg=https://amobilem.xyabcd.com/aiservice/live2d/Resources/005.jpg',
          model: 'Haru',
        },
      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.call-frame {
  overflow: hidden;
  position: relative;
  bottom: 62px;
  transition: all ease-in-out 0.6s;
  transform: translateY(70%);
  height: 560px;
  width: 94%;
  opacity: 0;
  img {
    position: absolute;
    z-index: 1;
    height: 560px;
  }
  &.active-list {
    transform: translateY(1%);
    height: 560px;
    opacity: 1;
  }
  .bg-top {
    top: 0;
    left: 0;
    right: 0;
    height: 40px;
  }

  .bg-left {
    top: 40px;
    left: 0;
    bottom: -2px;
    width: 9px;
    height: 85.7%;
  }

  .bg-right {
    top: 40px;
    right: 0;
    bottom: 0;
    height: 85.6%;
  }
  .bg-bot {
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
  }
}

.v3-style {
  z-index: 99;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  color: #01f0f9;
  display: flex;
  justify-content: space-between;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.765) 45%, transparent 100%);
  .header-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  .header-left {
    max-width: 460px;
    width: 30%;
    height: 100%;
    position: relative;
    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .header-left-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;

      .info-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.33%;
        height: 100%;
      }
    }
  }

  .customer {
    z-index: 1000;
    position: absolute;
    width: 363px;
    height: 630px;
    display: flex;

    align-content: stretch;
    flex-direction: column;
    align-items: center;
    bottom: -1220%;

    iframe {
      position: absolute;
      top: 12px;
      left: 9.9px;
      max-width: 94%;
      z-index: 2;
      max-height: 90%;
      border-radius: 22px 22px 0 0;
    }
    .call-button {
      position: absolute;
      width: 120px;
      height: 164px;
      overflow: hidden;
      bottom: 0;
      background: url('../../../assets/img/ai-model/ai_base.png') no-repeat;
      background-size: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        position: absolute;
      }
      .call-img-Hiyori {
        max-width: 42%;
        max-height: 44%;
        left: 46px;
      }
      .call-img-Haru {
        top: 40px;
        left: 22px;
        max-width: 80%;
        max-height: 80%;
      }
      .call-img-Mao {
        top: 52px;
        left: 38px;
        max-width: 46%;
        max-height: 40%;
      }
      .call-img-Natori {
        max-width: 40%;
        max-height: 40%;
        top: 54px;
        left: 43px;
      }
    }

    .ai-button {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  .right-icon {
    z-index: 1000;
    background: #031943;
    position: absolute;
    right: 0;
    bottom: -900%;
    width: 26px;
    height: 80px;
    border-radius: 6px 0 0 6px;
    border-top: 1px solid #148ddd;
    border-bottom: 1px solid #148ddd;
    border-left: 1px solid #148ddd;
    transition: all 0.2s ease-in-out;
    display: flex;
    align-items: center;
    .right-name {
      color: #fff;
      line-height: 28px;
      writing-mode: vertical-lr;
    }
    img {
      display: none;
    }
  }
  .right-icon:hover {
    width: 165.6px;
    height: 144px;
    padding: 0 10px;
    justify-content: space-between;
    border: none;
    .right-name {
      line-height: 16px;
      position: relative;
      left: 6px;
    }
    img {
      display: block;
      width: 150px;
    }
  }
  .header-middle {
    width: 30.5%;
    height: 100%;
    flex-shrink: 1;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .header-ProjectName {
      width: 100%;
      height: 100%;
      position: absolute;
      color: #f1f8f7;
      font-weight: 700;
      top: 0;
      display: flex;
      justify-content: center;

      p {
        margin: 0;
      }
    }
    .spotlight-ct {
      position: absolute;
      bottom: 2%;
      left: 50%;
      transform: translateX(-49.5%);
      width: 90%;
      height: 40%;
      overflow: hidden;
      .spotLight1 {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 28%;
        height: 20%;
        transform: translate(-50%, -50%);
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          #13d6c6 12%,
          rgba(189, 91, 87, 0) 60%,
          rgba(189, 91, 87, 0) 69%
        );
        animation: titlelight 6s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      .spotLight2 {
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          rgb(0, 255, 242) 9%,
          rgba(189, 91, 87, 0) 75%,
          rgba(189, 91, 87, 0) 73%
        );
        width: 9%;
        height: 20%;
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 11%;
        height: 14%;
        transform: translate(-50%, -50%);
        animation: titlelight 6s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      @keyframes titlelight {
        0% {
          left: -40%;
          opacity: 1;
          transform: scale(1.2, 1.3) translate(-50%, -50%);
        }
        35% {
          opacity: 0.7;
          transform: scale(1.6, 1.5) translate(-50%, -50%);
        }

        50% {
          opacity: 1;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }
        75% {
          opacity: 0.5;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }

        100% {
          left: 120%;
          opacity: 1;
          transform: scale(1.2, 1.2) translate(-50%, -50%);
        }
      }
    }
  }

  .header-right {
    max-width: 520px;
    width: 38%;
    height: 100%;
    position: relative;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-right-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;

      .info-item1 {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 50%;
        height: 100%;
        color: #01f0f9;
      }

      .info-item2 {
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: center;
        width: 28%;
        height: 80%;

        .info-item2-wrapper {
          width: 100%;
          height: 80%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .info-item2-hour {
          margin-left: 30%;
          display: flex;
          height: 34%;
          width: 70%;

          div {
            height: 100%;
            width: 10%;

            img {
              height: 100%;
              width: 100%;
              margin: 0;
              padding: 0;
            }
          }
        }

        .info-item2-date {
          margin-top: 5%;
          display: flex;
          height: 30%;
          width: 70%;

          div {
            height: 100%;
            width: 10%;

            img {
              height: 100%;
              width: 100%;
              margin: 0;
              padding: 0;
            }
          }
        }

        p {
          margin: 0;
          padding: 0;
        }
      }

      .info-item3 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25%;
        height: 100%;
      }
    }
  }
}
.icon {
  margin-right: 25px;

  img {
    cursor: pointer;
    min-width: 22px;
    min-height: 22px;
  }
}
.icon2 {
  margin-left: 0;
}
@media screen and (max-width: 1400px) {
  .call-frame {
    width: 86% !important;
  }
  .active-list {
    width: 86% !important;
  }
  .v3-style .customer iframe {
    max-height: 90% !important;
    top: 11px !important;
  }
  .customer {
    bottom: -1230% !important;
  }
  /* .call-frame .bg-left {
    top: 18% !important;
    height: 74.8% !important;
    width: 8px !important;
  }
  .call-frame .bg-top {
    top: 61.1px !important;
  }
  .call-frame .bg-right {
    top: 100.2px !important;
    height: 74.9% !important;
    width: 8px !important;
  } */
}
@media screen and (min-width: 3300px) {
  .v3-style .header-right .header-right-show-infos .info-item2 {
    height: 60% !important;
  }
  .v3-style .header-right .header-right-show-infos .info-item2 .info-item2-wrapper {
    height: 100% !important;
  }
  .v3-style .header-left {
    max-width: 528px !important;
  }
}
</style>
